"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _lockModule = _interopRequireDefault(require("./lock.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ObjectKey(props) {
  var data = props.data,
    onClick = props.onClick,
    keyName = props.keyName;
  var content = '';
  if ((0, _isObject2["default"])(data)) {
    for (var property in data) {
      content = data[property][keyName];
    }
  } else {
    content = data;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick && onClick,
    className: "".concat(_lockModule["default"].wrapper)
  }, content);
}
var _default = ObjectKey;
exports["default"] = _default;